import { getReverseProposal as getReverseProposalApi } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import type {
  GetReverseProposalServiceRequest,
  GetReverseProposalServiceResponse,
} from './get-reverse-proposal.dto';
import {
  GetReverseProposalServiceRequestSchema,
  GetReverseProposalServiceResponseSchema,
} from './get-reverse-proposal.dto';

export const getReverseProposalService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(GetReverseProposalServiceRequestSchema),
    async (
      request: GetReverseProposalServiceRequest,
    ): Promise<GetReverseProposalServiceResponse> => {
      const apiResponse = await getReverseProposalApi(request);

      if (apiResponse.meta?.result === 'FAIL') {
        throw new Error(apiResponse.meta?.message ?? '캠페인 역제안 상세 조회에 실패했습니다.');
      }

      return apiResponse.data;
    },
    validateServiceResponse(GetReverseProposalServiceResponseSchema),
  ),
);
